import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ImageIcon, Upload, RotateCcw } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { BRANDING_DEFAULT, HERO_DEFAULT, LOGO_DEFAULT, mediaSrc, resizeImage } from "@/lib/branding";

const inp = "w-full h-10 px-3 rounded-lg border text-sm outline-none focus:ring-2 focus:ring-[#B91C1C]";
const TEXTS = [
  ["shop_name", "Nama kedai (atas)"], ["shop_tagline", "Nama kecil (bawah nama kedai)"], ["welcome_text", "Teks alu-aluan"],
  ["hero_title", "Tajuk besar"], ["hero_subtitle", "Ayat kecil"], ["search_placeholder", "Teks kotak carian"],
];

function ImagePick({ label, value, fallback, onChange, maxW, type, id }) {
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    try { onChange(await resizeImage(file, maxW, type)); } catch (err) { toast.error(err.message); }
  };
  return (
    <div className="space-y-2">
      <span className="text-sm font-medium">{label}</span>
      <div className="flex items-center gap-3">
        <img src={mediaSrc(value) || fallback} alt="" className={`h-16 rounded-lg border bg-slate-50 ${id === "logo" ? "w-16 object-contain p-1" : "w-28 object-cover"}`} data-testid={`branding-${id}-preview`} />
        <label className="px-4 h-10 rounded-lg border border-[#B91C1C] text-[#B91C1C] text-sm font-semibold flex items-center gap-2 cursor-pointer active:scale-95 transition-transform">
          <Upload className="w-4 h-4" />Muat Naik
          <input type="file" accept="image/*" className="hidden" onChange={pick} data-testid={`branding-${id}-input`} />
        </label>
        {value && <button type="button" onClick={() => onChange("")} data-testid={`branding-${id}-reset`} className="p-2 rounded-lg border text-slate-500 hover:bg-slate-50" aria-label="Guna asal"><RotateCcw className="w-4 h-4" /></button>}
      </div>
    </div>
  );
}

export function BrandingCard({ req }) {
  const [b, setB] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/public/branding").then((r) => setB({ ...BRANDING_DEFAULT, ...r.data })).catch(() => setB(BRANDING_DEFAULT)); }, []);
  if (!b) return null;
  const set = (k, v) => setB((p) => ({ ...p, [k]: v }));
  const save = async () => {
    setBusy(true);
    try { setB(await req("put", "/staff/branding", b)); toast.success("Paparan halaman utama disimpan"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <section className="bg-white rounded-2xl border p-5 space-y-4" data-testid="branding-card">
      <h2 className="font-display font-bold text-lg flex items-center gap-2"><ImageIcon className="w-5 h-5 text-[#B91C1C]" />Paparan Halaman Utama</h2>
      <p className="text-xs text-slate-500">Tukar gambar dan perkataan yang pelanggan nampak di halaman utama app.</p>
      <ImagePick id="hero" label="Gambar latar banner" value={b.hero_image} fallback={HERO_DEFAULT} maxW={640} type="image/jpeg" onChange={(v) => set("hero_image", v)} />
      <ImagePick id="logo" label="Logo" value={b.logo_image} fallback={LOGO_DEFAULT} maxW={256} type="image/png" onChange={(v) => set("logo_image", v)} />
      <div className="grid sm:grid-cols-2 gap-3">
        {TEXTS.map(([k, label]) => (
          <label key={k} className="block space-y-1"><span className="text-sm font-medium">{label}</span>
            <input value={b[k]} onChange={(e) => set(k, e.target.value)} data-testid={`branding-${k}`} className={inp} /></label>
        ))}
      </div>
      <button onClick={save} disabled={busy} data-testid="branding-save" className="px-6 h-11 rounded-xl bg-[#B91C1C] text-white font-semibold active:scale-95 transition-transform disabled:opacity-60">{busy ? "Menyimpan..." : "Simpan Paparan"}</button>
    </section>
  );
}
